import currency from 'currency.js';
import { Table } from 'react-bootstrap';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { formatTransactiontDate } from '../../../helpers/date/date';
import { fetchReversedUserWithdrawalStart } from '../../../store/actions/WithDrawAction';

import NothingHere from '../../../images_new/icon/nothing_here.svg?react';
import { getStatusColor } from './IncomeStatement';
import { statementStatuses } from '../../../helpers/constants/statementStatuses';

const reversalStatuses = {
  1: 'Reverted',
  2: 'Failed',
};

const ReversedUserWithdrawals = () => {
  const dispatch = useDispatch()
  const reversedUserWithdrawals = useSelector((state) => state.withDraw.reversedUserWithdrawals);

  useEffect(() => {
    dispatch(fetchReversedUserWithdrawalStart());
  }, []);

  return (
    <div>
      <div className='security statement'>
        <div className='trans-table-sec'>
          <div className='trans-table'>
            <Table bordered={false} borderless={true} responsive>
              <thead>
                <tr>
                  <th>REVERSED ON</th>
                  <th>REASON</th>
                  <th>STATUS</th>
                  <th>WITHDRAWAL STATUS</th>
                  <th>AMOUNT</th>
                </tr>
              </thead>
              {reversedUserWithdrawals?.data && reversedUserWithdrawals?.data.length ? (
                <tbody>
                  {reversedUserWithdrawals?.data.map((transaction) => {
                    return (
                      <tr key={transaction.id}>
                        <td>{formatTransactiontDate(transaction.created_at)}</td>
                        <td>{transaction.message}</td>
                        <td
                          className={`hidden-xs status-text status-text-${getStatusColor(
                            reversalStatuses[transaction?.status],
                          )}`}
                        >
                          {reversalStatuses[transaction.status]}
                        </td>
                        <td
                          className={`hidden-xs status-text status-text-${getStatusColor(
                            statementStatuses[transaction?.user_withdrawal?.status],
                          )}`}
                        >
                          {statementStatuses[transaction?.user_withdrawal?.status]}
                        </td>
                        <td>{currency(transaction?.user_withdrawal?.requested_amount || 0).format()}</td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan={5}>
                      <div className='mt-3 nothing_here'>
                        <NothingHere />
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReversedUserWithdrawals;
